import api from "@/core/api/axios";
import { WhatsAppHealth } from "@superagents/types";

export type DisconnectInput = {
  reason: "change_number" | "issues" | "temporary_suspension" | "other";
  reason_details?: string;
};

export type DisconnectResult = {
  disconnectedAt: string;
  reason: DisconnectInput["reason"];
  providerStatus: "success" | "failed";
  providerError?: string;
};

// SA-1077: ids da conta Meta do setor para montar deep-links específicos.
export type SectorMetaIds = {
  businessId: string | null;
  wabaId: string | null;
  phoneNumberId: string | null;
};

type ApiEnvelope<T> = {
  success: boolean;
  code: number;
  message: string;
  data: T;
};

const authHeaders = (token: string | undefined | null) =>
  token ? { Authorization: `Bearer ${token}` } : undefined;

export const whatsappHealthApi = {
  async getHealth(
    sectorId: string,
    token: string | undefined | null,
    refresh?: boolean
  ): Promise<WhatsAppHealth.WhatsAppHealthSnapshot> {
    const response = await api().get<
      ApiEnvelope<WhatsAppHealth.WhatsAppHealthSnapshot>
    >(`/sectors/${sectorId}/whatsapp/health`, {
      headers: authHeaders(token),
      ...(refresh ? { params: { refresh: "true" } } : {}),
    });
    return response.data.data;
  },

  async getMetaIds(
    sectorId: string,
    token: string | undefined | null
  ): Promise<SectorMetaIds> {
    const response = await api().get<ApiEnvelope<SectorMetaIds>>(
      `/sectors/${sectorId}/whatsapp/meta-ids`,
      { headers: authHeaders(token) }
    );
    return response.data.data;
  },

  async disconnect(
    sectorId: string,
    input: DisconnectInput,
    token: string | undefined | null
  ): Promise<DisconnectResult> {
    const response = await api().post<ApiEnvelope<DisconnectResult>>(
      `/sectors/${sectorId}/whatsapp/disconnect`,
      input,
      { headers: authHeaders(token) }
    );
    return response.data.data;
  },
};
